import React from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';

import { Row, Col, Button, DropdownItem, ListGroup, InputGroup, Input, Progress, InputGroupAddon, InputGroupText } from 'reactstrap';

import styledMagstimTableWrapper from 'common/controls/StyledMagstimTableWrapper'
import { MagstimModalDateOfBirth, MagstimHeaderBar, MagstimDropdown, MagstimFetch, PatientTreatmentPlan, MagstimTableTreatmentHistory, MagstimColor, isPDA, magstim_clickHandler, magstim_eventHandler, getDropdownItems, CurrentLang, CurrentTheme, GetRange, DateUtils } from "common";
import { patientRoutesBase } from 'routes';
import { ENUM_STATUS_ARCHIVED } from 'common/EnumConstants';

import * as CsvUtils from 'common/utils/CsvUtils';

import { REST_ENDPOINT_MODEL_TREATMENT_PLAN, REST_ENDPOINT_TREATMENT_HISTORY } from 'common/ApiEndpoints';

const EXPORT_FILE_NAME = 'treatment-plan.csv'

class PatientTreatmentHistory extends React.Component {

	constructor() {
		super();

		this.state = {
			tableHeight: isPDA() ? 'calc(100vh - 426px)' : 'calc(100vh - 240px)',
			uiAsideHeight: isPDA() ? 'calc(100vh - 590px)' : 'calc(100vh - 60vh)',
			filterPadding: isPDA() ? '18px' : '38px',
			selectOptions: [],
			exportDisabled: false,
			exportFileName: EXPORT_FILE_NAME,
			patientDOB: {},
			treatmentData: {
				listitems: [],
				planName: '',
				numberTreatments: 1
			},
			noDataPanelLayout: {
				noDataPanelMargin: isPDA() ? '10px' : '100px',
				noDataPanelIconFontSize: isPDA() ? '50px' : '120px',
				noDataPanelTitleFontSize: isPDA() ? '18px' : '24px',
				noDataPanelBodyFontSize: isPDA() ? '12px' : '16px',
			}
		};

		this._table = React.createRef();
		this._clinicianFilter = React.createRef();
		this._dateFilter = React.createRef();
		this._modal = React.createRef();

		window._PatientTreatmentHistory_initForSelect = this.initForSelect.bind(this);
		window._initPatientTreatmentPlan = this.initPatientTreatmentPlan.bind(this);
		window._clearAllData = this.clearAllData.bind(this);
	}


	onSelectFilter = (id) => {
		this._table.current.addFilter('performedBy', id);
	}

	onSelectDate = (id) => {
		const range = GetRange(id);

		magstim_eventHandler('select', 'date', range);
		this._table.current.addFilter('date', range);
	}

	// eslint-disable-next-line no-unused-vars
	onClickExport = (event) => {
		// console.log('onClickExport');

		if (isPDA()) {
			CsvUtils.downloadAsCSV(document, this.state.exportFileName, this._table.current.getColumns(), this._table.current.getFilteredData());
		} else {
			magstim_clickHandler('export', CsvUtils.toCsv(this._table.current.getColumns(), this._table.current.getFilteredData()));
		}
	}

	// eslint-disable-next-line no-unused-vars
	onClickEdit = (event) => {
		magstim_clickHandler('edit');

		if (this.props.history) {
			this.onTreatmentEdit();
		}
	}

	onTreatmentEdit = () => {
		this._modal.current.show(CurrentLang().date_of_birth_conformation_title,
			CurrentLang().date_of_birth_conformation_message,
			CurrentLang().message_box_OK,
			CurrentLang().message_box_cancel,
			this.openTreatmentEdit);
	}

	openTreatmentEdit = (buttonText, dateOfBirth) => {
		if (buttonText === CurrentLang().message_box_OK) {
			if (DateUtils.dateMatches(this.state.patientDOB, dateOfBirth)) {
				this.props.history.push({ pathname: `${patientRoutesBase}/${this.props.match.params.PatientGuid}/BuildTreatmentPlan` })
			}
			else {
				this.props.showModal(CurrentLang().date_of_birth_conformation_title, CurrentLang().date_of_birth_error);
			}
		}
	}

	// eslint-disable-next-line no-unused-vars
	onClickUnassign = (event) => {
		magstim_clickHandler('unassign');

		if (isPDA()) {
			this._modal.current.show(CurrentLang().date_of_birth_conformation_title,
				CurrentLang().date_of_birth_conformation_message,
				CurrentLang().message_box_OK,
				CurrentLang().message_box_cancel,
				this.onClickUnassignCallBack);
		}
	}

	onClickUnassignCallBack = (buttonText, dateOfBirth) => {
		if (buttonText === CurrentLang().message_box_OK) {
			if (DateUtils.dateMatches(this.state.patientDOB, dateOfBirth)) {
				this.unassignTreatmentPlan();
			}
			else {
				this.props.showModal(CurrentLang().date_of_birth_conformation_title, CurrentLang().date_of_birth_error);
			}
		}
	}


	unassignTreatmentPlan = () => {

		MagstimFetch.get(REST_ENDPOINT_MODEL_TREATMENT_PLAN, this.state.treatmentData.TreatmentPlanGuid)
			.then((data) => {
				data.Status = ENUM_STATUS_ARCHIVED;
				MagstimFetch.put(REST_ENDPOINT_MODEL_TREATMENT_PLAN, this.state.treatmentData.TreatmentPlanGuid, data)
					.then((dataPut) => {
						this.loadDataFromAPI();
					})
					.catch((error) => {
						this.props.handleError(error);
					});
			})
			.catch((error) => {
				this.props.handleError(error);
			});

	}

	cellClickCallback = (row, column, cell) => {
		console.log('cellClickCallback', row, column, cell);
		if (this.props.history) {
			this.props.history.push({ pathname: `${patientRoutesBase}/${this.props.match.params.PatientGuid}/Treatments/History/${row.protocolGUID}` });
		}
	}

	initPatientTreatmentPlan = (data) => {
		this.setState({
			treatmentData: data,
		});
	}

	render() {
		let clinicianHeaderItems = [<DropdownItem key={CurrentLang().treatment_history_all_treaters} active>{CurrentLang().treatment_history_all_treaters}</DropdownItem>, <DropdownItem key="divider" divider />];

		let clinicianItems = clinicianHeaderItems.concat(this.state.selectOptions.map((key, index) => (
			<DropdownItem id={this.state.selectOptions[index]}
				key={index}
				active={key === 0}
			>{this.state.selectOptions[index]}</DropdownItem>
		)));

		var progressValue = '';
		var unassignPlanDisabled = true;
		if ((undefined !== this.state.treatmentData) && (null !== this.state.treatmentData)) {

			if ((undefined !== this.state.treatmentData.listitems) && (null !== this.state.treatmentData.listitems) && (this.state.treatmentData.listitems.length > 0)) {
				unassignPlanDisabled = false;
			}

			if ((undefined !== this.state.treatmentData.numberComplete)
				&& (undefined !== this.state.treatmentData.numberTreatments)
				&& (this.state.treatmentData.numberTreatments > 0)) {
				progressValue = this.state.treatmentData.numberComplete + "/" + this.state.treatmentData.numberTreatments + ' ' + CurrentLang().patient_home_treatments_completed;
			}
		}

		var planHeader;
		var planList;
		var progressText;
		var progressBar;
		var commandButtons;

		if (!unassignPlanDisabled) {

			planHeader = <Row>
				<Col className="mt-3 m-2">
					<MagstimHeaderBar
						main_title={this.state.treatmentData.planName}
						ShowClose={false}
					/>
				</Col>
			</Row>;

			planList = <Row className="pt-2 pb-2 pl-4 pr-4">
				<Col className="ui-scroll">
					<ListGroup className="treatmentCard">
						{
							Object.keys(this.state.treatmentData.listitems).map((key, index) => (
								<PatientTreatmentPlan
									index={index}
									data={this.state.treatmentData.listitems[key]}
									key={'TreatmentPlan' + key}
								/>
							))
						}
					</ListGroup>
				</Col>
			</Row>

			progressText = <InputGroup size="sm">
				<InputGroupAddon addonType="prepend">
					<InputGroupText className="w-100">Total</InputGroupText>
				</InputGroupAddon>
				<Input value={progressValue} type="text" className="text-right" disabled />
			</InputGroup>;

			progressBar = <Row className="mt-1 mb-2">
				<Col>
					<Progress color="success" value={this.state.treatmentData.numberComplete / this.state.treatmentData.numberTreatments * 100} />
				</Col>
			</Row>;

			commandButtons = <Row className="mt-1">
				<Col>
					<Button color="primary" onClick={this.onClickEdit} size={CurrentTheme().ControlSize} className="w-100 mb-3" ><i className="fas fa-edit" /> {CurrentLang().patient_home_edit_treatment_plan}</Button>
					<Button disabled={unassignPlanDisabled} onClick={this.onClickUnassign} color="secondary" size={CurrentTheme().ControlSize} className="w-100 mb-3"><i className="fas fa-times-circle"></i> {CurrentLang().treatment_history_unassign_plan}</Button>
				</Col>
			</Row>
		}
		else {

			planList = <NoDataPanel className={"ui-panel d-block"} noDataPanelLayout={this.state.noDataPanelLayout} >
				<p><i className="fas fa-file-prescription" /> </p>
				<p><strong>{CurrentLang().patient_home_no_plan_assigned}</strong></p>
				<p>{CurrentLang().patient_home_no_plan_assigned_instructions}</p>
			</NoDataPanel>

			commandButtons = <Row className="mt-1">
				<Col className="p-4">
					<Button onClick={this.onClickEdit} size={CurrentTheme().ControlSize} className="w-100 mb-3" ><i className="fas fa-file-prescription" /> {CurrentLang().patient_home_assign_treatment_plan}</Button>
				</Col>
			</Row>
		}
		return (
			<Wrapper className="ui-fillh" tableHeight={this.state.tableHeight} uiAsideHeight={this.state.uiAsideHeight} filterPadding={this.state.filterPadding}>
				<MagstimModalDateOfBirth ref={this._modal}></MagstimModalDateOfBirth>
				<Row className="ui-fillh">

					<Col lg="3" md="12" className="ui-fillh">

						<div className="ui-fillh ui-aside">

							<Row className="ui-header ml-0 mr-0">
								<Col >
									<MagstimHeaderBar
										main_title={CurrentLang().patient_history_plan_title}
										main_icon="fas fa-file-prescription"
										ShowClose={false}
									/>
								</Col>
							</Row>

							<Row className="ui-main">

								<Col>
									{planHeader}
									{planList}
									<Row>
										<Col className="mr-2 ml-2">
											{progressText}
											{progressBar}
											{commandButtons}
										</Col>
									</Row>
								</Col>
							</Row>
						</div>
					</Col>

					<Col lg="9" md="12" className="ui-fillh">
						<Row className="ui-header ml-0">
							<Col md="4" sm="12">
								<MagstimHeaderBar
									main_title={CurrentLang().home_treatments}
									ShowClose={false}
								></MagstimHeaderBar>
							</Col>

							<Col md="4" sm="12" className="mt-auto mb-auto filter-dropdown">
								<MagstimDropdown id="clinician" ref={this._clinicianFilter} onSelect={this.onSelectFilter} icon='fas fa-user-md' >
									{clinicianItems}
								</MagstimDropdown>
							</Col>

							<Col md="4" sm="12" className="mt-auto mb-auto filter-dropdown">
								<MagstimDropdown id="treatmentDate" ref={this._dateFilter} onSelect={this.onSelectDate} icon='fas fa-calendar-alt' >
									<DropdownItem key="allTime" id='allTime' active>{CurrentLang().treatment_history_date_allTime}</DropdownItem>
									<DropdownItem key="divider" divider />
									<DropdownItem key="lastWeeks4" id='lastWeeks4'>{CurrentLang().treatment_history_date_lastWeeks4}</DropdownItem>
									<DropdownItem key="lastMonths6" id='lastMonths6'>{CurrentLang().treatment_history_date_lastMonths6}</DropdownItem>
									<DropdownItem key="lastMonths12" id='lastMonths12'>{CurrentLang().treatment_history_date_lastMonths12}</DropdownItem>
								</MagstimDropdown>
							</Col>

						</Row>

						<Row className="ui-main ui-bg ml-0">
							<Col>
								<Row>
									<Col>
										<div className="table-area mt-3">
											<MagstimTableTreatmentHistory ref={this._table} div_name="tbTreatmentHistory" cellClickCallback={this.cellClickCallback}></MagstimTableTreatmentHistory>
										</div>
									</Col>
								</Row>
								<Row>
									<Col className="pt-2 pr-4 m-3 text-right">
										<Button color="primary" disabled={this.state.exportDisabled} className="pl-5 pr-5" onClick={this.onClickExport} size={CurrentTheme().ControlSize}><i className="fas fa-file-excel pr-2"></i> {CurrentLang().table_export_title}</Button>
									</Col>
								</Row>
							</Col>
						</Row>
					</Col>

				</Row>
			</Wrapper>
		);
	}

	componentDidMount() {
		if (isPDA()) {
			this.loadDataFromAPI();
		}
	}

	componentWillUnmount() {
		this.props.setCurrentPatientID("");
	}

	loadDataFromAPI() {
		MagstimFetch.get(REST_ENDPOINT_TREATMENT_HISTORY, this.props.match.params.PatientGuid)
			.then((data) => {
				// console.log('loadDataFromAPI', data);
				this.initForSelect(data.history);
				this.initForTreatment(data.currentTreatment);

				if ((undefined !== data.patientDetail) && (null !== data.patientDetail)) {
					var userNameAndID = `${data.patientDetail.FirstName} ${data.patientDetail.LastName} - ${data.patientDetail.PatientIdNum}`;
					this.props.setCurrentPatientID(userNameAndID);
					this.setState({ exportFileName: `${userNameAndID}-${EXPORT_FILE_NAME}`, patientDOB: data.patientDetail.DOB })
				}
			})
			.catch((error) => {
				this.props.handleError(error);
			});
	}

	initForSelect(data) {
		//console.log(`PatientTreatmentHistory.initForSelect data=${JSON.stringify(data, null, 4)}`);

		if (this._table && this._table.current) {
			this._table.current.initForSelect(data);
			this._table.current.resetFilters();

			this.setState({
				exportDisabled: (0 === data.length) || ((1 === data.length) && (undefined !== data[0].__dummy_no_data_row) && data[0].__dummy_no_data_row),
				selectOptions: getDropdownItems('tbTreatmentHistory', 'clinician', 'performedBy')
			});
		}
	}

	completedPercent = (completed, outOf) => {
		let asPercent = (100 * completed) / outOf;
		return asPercent;
	};

	initForTreatment(data) {
		this.setState({
			treatmentData: data
		});
	}

	clearAllData() {

		this.setState({
			selectOptions: [],
			exportDisabled: false,
			exportFileName: EXPORT_FILE_NAME,
			patientDOB: {},
			treatmentData: {
				listitems: [],
				planName: '',
				numberTreatments: 0
			}
		});

		this._table.current.initForSelect([]);
	}
}

const NoDataPanel = styled.div`
	margin: 16px;
	padding: 24px;
	padding-top: ${props => props.noDataPanelLayout.noDataPanelMargin};
	padding-bottom: ${props => props.noDataPanelLayout.noDataPanelMargin};
    text-align: center;
	vertical-align: middle;
	color: ${MagstimColor.MagstimGrey109};
	i {
		font-size: ${props => props.noDataPanelLayout.noDataPanelIconFontSize};
	}
	p {
		font-size: ${props => props.noDataPanelLayout.noDataPanelBodyFontSize};
	}
	strong {
		font-size: ${props => props.noDataPanelLayout.noDataPanelTitleFontSize};
	}
`;

const Wrapper = styled(styledMagstimTableWrapper)`

.ui-header{
	color: ${MagstimColor.MagstimGroupHeaderText};
	background-color: ${MagstimColor.MagstimCardHeaderBackground};
}

.filter-dropdown{
	padding-right: ${props => props.filterPadding};
}

.ui-aside {

	background-color: ${MagstimColor.MagstimGroupBackground};
	
	.ui-scroll {
		height: ${props => props.uiAsideHeight};
	}

	.ui-scroll::-webkit-scrollbar {
			width:20px; /*  manage scrollbar width here */
	}

	
	.treatmentCard {
		.container-fluid {
			padding-bottom: 0;
		}
		.card {
			border: none;
			margin-bottom: 1rem;
			padding-bottom: 0;
			border-radius: 6px;
			background-color: ${MagstimColor.MagstimGroupBackground};
			
		}

		.ui-card {
			padding-top: 10px;
			background-color: ${MagstimColor.MagstimGroupBackground};

			.ui-header {
				display: none;
			}
			.ui-panel {
				background-color: ${MagstimColor.MagstimGroupBackground};
			}
		}
	}


	.input-group {
		line-height: 40px;
		height: 40px;

		.input-group-text {
			background: transparent;
			color: ${MagstimColor.MagstimWhite};
			font-weight: 600;
			border: none;
		}
		input, input:disabled {
			border: none !important;
		}
	}

	.progress {
		background-color: ${MagstimColor.MagstimGrey74};

		.bg-success {
			background-color: ${MagstimColor.MagstimLightBlue} !important;
		}
	}
}

`;

export default isPDA() ? withRouter(PatientTreatmentHistory) : PatientTreatmentHistory;

